(function(){
'use strict';

var CHECK_SVG='<svg viewBox="0 0 12 12"><path d="M2 6l3 3 5-5"/></svg>';
var COMPAT_PROGRAMS=['GSPro','E6 Connect','TGC 2019','ProTee Labs','Awesome Golf','CreativGolf','WGT','Trackman'];

function findDescEl(){
  var selectors=['.product-description .rte','.product-description','[class*="description__content"]','.description-content','.rte-content','.product__description','[data-product-description]','.main-product__info .rte','.product-detail__description'];
  for(var i=0;i<selectors.length;i++){
    var el=document.querySelector(selectors[i]);
    if(el&&el.textContent.indexOf('\u25ba')>-1)return el;
    if(el&&el.textContent.indexOf('Ball Data')>-1)return el;
  }
  var all=document.querySelectorAll('.rte,[class*="description"]');
  for(var j=0;j<all.length;j++){if(all[j].textContent.indexOf('\u25ba')>-1)return all[j];}
  return null;
}

function parseSections(el){
  var sections={};var current=null;
  Array.from(el.childNodes).forEach(function(node){
    if(node.nodeType===1){
      var text=(node.textContent||'').trim();
      if(text.indexOf('\u25ba')>-1||text.match(/^(Ball Data|Club Data|What\u2019s Included|Launch Monitor Spec|PC|Software|Compatibility)/i)){
        var label=text.replace(/[\u25ba\u2022\*\-]/g,'').trim();
        current=label;if(!sections[current])sections[current]=[];
      }else if(current){
        var items=node.querySelectorAll('li');
        if(items.length){items.forEach(function(li){sections[current].push(li.textContent.trim())});}
        else if(text){sections[current].push(text);}
      }
    }
  });
  return sections;
}

function makeBadges(items){return items.map(function(t){return'<span class="sng-badge sng-yes">'+CHECK_SVG+escH(t)+'</span>';}).join('');}

function makeSpecTable(items){
  var rows=items.map(function(t){
    var parts=t.split(':');
    if(parts.length>=2){return'<tr><td>'+escH(parts[0].trim())+'</td><td>'+escH(parts.slice(1).join(':').trim())+'</td></tr>';}
    return'<tr><td colspan="2">'+escH(t)+'</td></tr>';
  }).join('');
  return'<table class="sng-spec-table">'+rows+'</table>';
}

function makeIncluded(items){
  var icons=['<svg viewBox="0 0 24 24"><rect x="3" y="10" width="18" height="11" rx="2"/><circle cx="12" cy="15" r="2"/><path d="M8 10V6a4 4 0 018 0v4"/></svg>','<svg viewBox="0 0 24 24"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M8 10h8M8 14h5"/></svg>','<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M12 12v8M8 16h8"/></svg>','<svg viewBox="0 0 24 24"><path d="M18 16l-6-6-6 6"/><path d="M12 10v10M3 6l9-3 9 3"/></svg>','<svg viewBox="0 0 24 24"><rect x="2" y="6" width="20" height="12" rx="2"/><path d="M2 10h20"/></svg>','<svg viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>'];
  return'<div class="sng-included-grid">'+items.map(function(t,i){return'<div class="sng-included-card"><div class="sng-included-card-icon">'+icons[i%icons.length]+'</div><h5>'+escH(t)+'</h5></div>';}).join('')+'</div>';
}

function makeCompatGrid(items){
  return'<div class="sng-compat-grid">'+items.map(function(t){
    var yes=COMPAT_PROGRAMS.some(function(p){return t.toLowerCase().indexOf(p.toLowerCase())>-1;});
    return'<div class="sng-compat-item"><span class="sng-compat-dot '+(yes?'yes':'no')+'"></span><span>'+escH(t)+'</span></div>';
  }).join('')+'</div>';
}

function makeBullets(items){return'<ul class="sng-spec-bullets">'+items.map(function(t){return'<li>'+escH(t)+'</li>';}).join('')+'</ul>';}

function escH(s){return(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}

function normKey(k){
  k=k.toLowerCase().trim();
  if(k.indexOf('ball')>-1)return'ball';
  if(k.indexOf('club')>-1&&k.indexOf('data')>-1)return'club';
  if(k.indexOf('spec')>-1||k.indexOf('technical')>-1)return'specs';
  if(k.indexOf('included')>-1||k.indexOf('box')>-1)return'included';
  if(k.indexOf('compat')>-1||k.indexOf('software')>-1)return'compat';
  return'other_'+k.replace(/\s+/g,'_');
}

function tabLabel(k){
  var labels={ball:'Ball data',club:'Club data',specs:'Specifications',included:"What's included",compat:'Compatibility'};
  return labels[k]||k.replace(/_/g,' ');
}

function renderSection(key,items){
  if(!items||!items.length)return'<p style="color:#aaa;font-size:13px;">No data available.</p>';
  if(key==='ball'||key==='club')return makeBadges(items);
  if(key==='specs')return makeSpecTable(items);
  if(key==='included')return makeIncluded(items);
  if(key==='compat')return makeCompatGrid(items);
  return makeBullets(items);
}

function build(){
  var descEl=findDescEl();
  if(!descEl)return;
  var rawSections=parseSections(descEl);
  var keys=Object.keys(rawSections);
  if(keys.length<2)return;
  var normSections={};
  keys.forEach(function(k){var nk=normKey(k);normSections[nk]=(normSections[nk]||[]).concat(rawSections[k]);});
  var tabOrder=['ball','club','specs','included','compat'];
  var otherKeys=Object.keys(normSections).filter(function(k){return tabOrder.indexOf(k)<0;});
  var allTabs=tabOrder.concat(otherKeys).filter(function(k){return normSections[k]&&normSections[k].length;});
  if(!allTabs.length)return;
  var firstTab=allTabs[0];
  var title=document.querySelector('h1.title,.product-title h1,h1[class*="product"]');
  var vendor=document.querySelector('.product-vendor,.vendor');
  var heroHTML='';
  if(title){heroHTML='<div class="sng-spec-hero-bar"><div class="sng-spec-hero-icon"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3.5"/></svg></div><div class="sng-spec-hero-text"><h4>'+escH(title.textContent.trim())+'</h4>'+(vendor?'<p>'+escH(vendor.textContent.trim())+'</p>':'')+'</div></div>';}
  var tabsHTML=allTabs.map(function(k){return'<button class="sng-spec-tab'+(k===firstTab?' active':'')+'" data-tab="'+k+'">'+tabLabel(k)+'</button>';}).join('');
  var panelsHTML=allTabs.map(function(k){return'<div class="sng-spec-panel'+(k===firstTab?' active':'')+'" data-panel="'+k+'">'+renderSection(k,normSections[k])+'</div>';}).join('');
  var html='<div class="sng-spec-wrap">'+heroHTML+'<div class="sng-spec-tabs">'+tabsHTML+'</div>'+panelsHTML+'<div class="sng-cta-row"><p>Have questions about this product?</p><a href="/pages/contact">Talk to our team</a></div></div>';
  var wrapper=document.createElement('div');
  wrapper.innerHTML=html;
  wrapper.querySelectorAll('.sng-spec-tab').forEach(function(btn){
    btn.addEventListener('click',function(){
      var key=btn.dataset.tab;
      wrapper.querySelectorAll('.sng-spec-tab').forEach(function(b){b.classList.toggle('active',b.dataset.tab===key);});
      wrapper.querySelectorAll('.sng-spec-panel').forEach(function(p){p.classList.toggle('active',p.dataset.panel===key);});
    });
  });
  descEl.parentNode.insertBefore(wrapper,descEl);
  descEl.style.display='none';
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',build);}else{build();}

})();